import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

function ChevronIcon() {
  return (
    <svg className='size-3 text-neutral-400' viewBox='0 0 12 12' fill='none' stroke='currentColor' strokeWidth='2'>
      <path d='M4.5 2.5L8 6L4.5 9.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav className='flex items-center gap-2'>
      {items.map((item, i) => (
        <span key={item.label} className='flex items-center gap-2'>
          {i > 0 && <ChevronIcon />}
          {item.to ? (
            <Link className='font-mediumbold text-sm text-neutral-600 focus:outline-none' to={item.to}>
              {item.label}
            </Link>
          ) : (
            <span className='font-mediumbold text-sm text-neutral-900'>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
